<ng-content select="[modalClose]" />

<div class="modal-body-content__indicator" aria-hidden="true">
  <ng-content select="[modalIndicator]" />
</div>

<h2 [id]="titleId()" class="h5 modal-body-content__title">{{ title() }}</h2>
<p [id]="descriptionId()" class="modal-body-content__description mb-0">
  {{ description() }}
  <ng-content select="[modalDescriptionExtra]" />
</p>

<ng-content select="[modalHint]" />
